import StackAPI from '@/lib/StackAPI'

const ENDPOINT = '/partners/user/passwords'
export const UNKNOWN_PASSWORD_UPDATE_ERROR = 'unknown error'

function extractApiErrors(data: unknown): string {
  const errors = (data as { errors?: unknown })?.errors
  if (Array.isArray(errors)) {
    return (
      errors.map((e) => (typeof e === 'string' ? e : String(e))).join(', ') ||
      UNKNOWN_PASSWORD_UPDATE_ERROR
    )
  }
  if (typeof errors === 'string') return errors
  return UNKNOWN_PASSWORD_UPDATE_ERROR
}

export const updateOrgUserPassword = async (
  password: string,
  email: string
) => {
  const { put } = StackAPI()

  const request = {
    path: ENDPOINT,
    params: {
      email,
      password
    },
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json'
    }
  }

  return await put(request)
    .then((response) => {
      if (response.status !== 200) {
        return { error: extractApiErrors(response.data) }
      }
      return response.data
    })
    .catch((error) => ({
      error: extractApiErrors(error?.response?.data)
    }))
}
